function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M31 12c2.76 0 5 2.24 5 5v14c0 2.76-2.24 5-5 5H17c-2.76 0-5-2.24-5-5V17c0-2.76 2.24-5 5-5zm0 3H17l-.192.01A2.003 2.003 0 0 0 15 17v14l.01.192A2.003 2.003 0 0 0 17 33h14l.192-.01A2.003 2.003 0 0 0 33 31V17l-.01-.192A2.003 2.003 0 0 0 31 15zm-6 3.586v6.586l2.293-2.293 1.414 1.414L24 29l-4.707-4.706 1.414-1.414L23 25.172v-6.586h2z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/zapisz.8e1d2275.svg";
export { SvgComponent as ReactComponent };